/**
 * @graph-stack product-innovation-lab
 * @graph-domain Infrastructure
 * @graph-business PILabフロントエンドのエントリーポイント。Faro初期化後にReact StrictMode + Appをrootにマウント
 * @graph-connects none
 */
// Faro初期化は他のimportより前に実行
import { initializeFaro } from '@cortex/faro';
initializeFaro({ appName: 'product-innovation-lab' });

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';
import './i18n';

// タブを開いたまま新しいデプロイが入ると、コード分割されたチャンク（mermaid等）の
// ハッシュ付きファイル名が変わり、古いタブは存在しないファイルを参照し続けて
// 動的import が恒久的に失敗する（業務フロー図が描画されないまま固まる）。
// リロードして最新のファイル一覧を取り直す。sessionStorage には直近のリロード
// 時刻だけを記録し、一定時間内の再発（＝リロードしても直らない別原因）だけを
// ループとして止める。クールダウンを過ぎた再発は別デプロイによる新しい事象として
// 扱い、タブを開いたまま複数デプロイをまたいでも毎回 1 回は自動リロードする。
/** @graph-connects none */
const PRELOAD_RELOAD_AT_KEY = 'vite-preload-reload-at';
/** @graph-connects none */
const PRELOAD_RELOAD_COOLDOWN_MS = 10_000;

window.addEventListener('vite:preloadError', () => {
  const lastReloadAt = Number(sessionStorage.getItem(PRELOAD_RELOAD_AT_KEY) ?? '0');
  if (Date.now() - lastReloadAt < PRELOAD_RELOAD_COOLDOWN_MS) return;
  sessionStorage.setItem(PRELOAD_RELOAD_AT_KEY, String(Date.now()));
  window.location.reload();
});

/** @graph-connects none */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
